import { render, staticRenderFns } from "./MusteriForm.vue?vue&type=template&id=0c5360dd&scoped=true&"
import script from "./MusteriForm.vue?vue&type=script&lang=js&"
export * from "./MusteriForm.vue?vue&type=script&lang=js&"
import style0 from "./MusteriForm.vue?vue&type=style&index=0&id=0c5360dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5360dd",
  null
  
)

export default component.exports